const CDN = /^https?:\/\/assets\.auxodev\.dk\/assets\/[^/]+\//;
export const assetPath = (u) => { 
  const s = String(u || '').trim(); 
  if (!s) return ''; 
  if (s.startsWith('/_assets/')) return s; 
  if (CDN.test(s)) return '/_assets/' + s.replace(CDN, ''); 
  const m = s.match(/^\/?assets\/[^/]+\/(.+)$/); 
  if (m) return '/_assets/' + m[1]; 
  if (/^[^/\?#:]+\.(png|jpe?g|webp|gif|avif|svg|mp4|webm|mov|pdf|woff2?)$/i.test(s)) return '/_assets/' + s; 
  return s; 
};

export const imageUrl = (u, opts = 'width=800,quality=80,format=auto') => { 
  const p = assetPath(u); 
  if (!p.startsWith('/_assets/') || p.includes('/cdn-cgi/image/')) return p; 
  return '/cdn-cgi/image/' + opts + p; 
};

export const srcSet = (u, widths = [400, 800, 1200]) => 
  widths.map((w) => imageUrl(u, 'width=' + w + ',quality=80,format=auto') + ' ' + w + 'w').join(', ');
